module.exports = __webpack_public_path__ + "static/media/case5A.3997131.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case5A.mp4
// module id = mUza
// module chunks = 0